import React from "react";
export const EmpiricaContext = React.createContext(null);
export const NSContext = React.createContext(null);
export const URLContext = React.createContext("");
export const OnPlayerIDContext = React.createContext(null);
export const GlobalContext = React.createContext(null);
